export default {
	title: 'Dobrý den!',
	title_1: 'Dobré ráno!',
	title_2: 'Dobré dopoledne!',
	title_3: 'Dobré poledne!',
	title_4: 'Dobré odpoledne!',
	title_5: 'Dobrý podvečer!',
	title_6: 'Dobrý večer!',
	detail: 'Detail',

	todaysUrgencies: {
		title: 'Dnešní urgence',
		unpaidFirstPayment: 'Nezaplacená první platba {{productDomain}} (sjednání podpisem) u ',
		leadsInProgress: 'Máte rozpracovanou příležitost, které se blíží termín splnění a čeká na vyřízení - ',
		campaignsNearingTheEnd: 'Blížící se konec kampaně, ve které existují nevyřízené kontakty',
		campaignsNearingTheEndManager: 'Blížící se termín konce kampaně',
		campaignsNearingTheEndContactRelease:
			'Blížíce se termín konce kampaně, ve které existují kontakty, které nebyly uvolněny.',
		leadsToProcess: 'Evidujeme rozpracovanou příležitost, které se blíží termín splnění a čeká na vyřízení.',
		policy_one: '{{count}} smlouvy',
		policy_few: '{{count}} smluv',
		policy_other: '{{count}} smluv',
		lead_one: '{{count}} příležitost',
		lead_few: '{{count}} příležitosti',
		lead_other: '{{count}} příležitostí',
		POV: 'POV',
		HAV: 'HAV',
		SME: 'SME',
		ONZP: 'ONŽP',
		ZP: 'ŽP',
		escalationBasic: 'Odeslání eskalace z úkolu Požadavek na obchodníka a Kontaktuj klienta ',
		escalationSummary: 'Odeslané eskalace o neplnění úkolů podřízených ',
		consultant_one: '{{count}} poradce',
		consultant_few: '{{count}} poradci',
		consultant_other: '{{count}} poradců',
	},

	marketPlace: {
		availableLeadsTitle: 'Tržiště',
		takenLeadsTitle: 'Převzato z tržiště',
		taken: 'Převzato',
		draft: 'Rozpracováno',
		noAvailableLeadsToTake: 'V tržišti není žádná nová příležitost k převzetí.',
		noTakenLeads: 'Nemáte převzatou žádnou příležitost z tržiště.',
	},

	semaphore: {
		title: 'Semafor - Hrozící stav',
		to1Month: 'Do 1 měsíce',
		to2Months: 'Do 2 měsíců',
		to3Months: 'Do 3 měsíců',
	},

	campaigns: {
		title: 'Kampaně',
		campaignName: 'Název kampaně',
		daysLeft: 'Zbývá dnů',
		inProgress: 'K vyřízení',
		draft: 'Rozpracované',
		fulfillment: 'Vyřízenost',
		production: 'Produkce',
		total: 'Celkem',
		contacts: 'kontaktů',
		noCampaigns: 'Nemáte přidělené žádné nevyřešené kontakty.',
	},

	tasksAndInformation: {
		title: 'Úkoly a informace',
		newTasksToSolve: 'Nové úkoly k řešení',
		allInformationToSolve: 'Celkem k vyřízení informací',
		newInformationToSolve: 'Nové informace k řešení',
	},

	leads: {
		title: 'Příležitosti',
		current: 'Aktuální',
		draft: 'Rozpracováno',
		noCurrentLeads: 'Nemáte žádnou příležitost k řešení.',
		noDraftLeads: 'Nemáte žádnou rozpracovanou příležitost.',
	},

	statistics: {
		title: 'Statistika',
		titleTooltip:
			'Statistika úkolů a příležitostí neobsahuje data za podřízené podobchodníky. Statistika kontaktů v kampani je včetně dat podobchodníků.',
		myTeam: 'Celý tým',
		businessEvents: 'Obchodní události',
		bruttoProductionAndTeamActivities: 'Brutto produkce',
		seller: 'Obchodník',
		tasks: 'Úkoly',
		leads: 'Příležitosti',
		contacts: 'Kontakty',
		tasksSubTitle: 'Celkem/Po termínu',
		leadsSubTitle: 'Celkem/Z tržiště',
		contactsSubTitle: 'Celkem/Nezpracováno',
		newPoliciesCount: 'Počet kusů nových PS',
		period: 'Období:',
		periodTooltip:
			'Data v tabulce se přepočítají dle zvoleného období. Hodnoty jsou s dvoudenním zpožděním. Tj. aktuální den mínus 2 dny.',
		todayMinusTwoDays: 'Den -2',
		week: 'Týden',
		month: 'Měsíc',
		campaignsProduction: 'Produkce z kampaní',
		inTime: 'V termínu',
		beforeDeadline: 'Před termínem',
		afterDeadline: 'Po termínu',
		information: 'Informace',
		toProcess: 'Ke zpracování',
		drafts: 'Rozpracované',
		processed: 'Zpracované',
		inMarketPlace: 'V tržišti',
		assigned: 'Převzato',
		leadTypes: {
			birthday: 'Narozeniny',
			nameday: 'Jmeniny',
			lifePolicyAnniversary: 'Smlouva ŽP u GČP 5 a 10 let',
			clientAnniversary: 'Výročí klienta u GČP 3, 5 a 10 let',
			leadFromWeb: 'Lead z webu',
			businessOpportunity: 'Obchodní příležitost',
			life: 'Lead ŽP',
			portfolioOpportunity: 'Příležitost z portfolia',
			marketplace: 'Příležitosti v tržišti',
			acquisitionsContacts: 'Akviziční kontakty',
			businessOpportunitySME: 'Obchodní příležitost SME',
		},
	},

	campaignManagement: {
		title: 'Řízení kampaní',
		allCampaigns: 'Všechny kampaně',
		noCampaigns: 'Nemáte žádnou běžící kampaň s přidělenými kontakty.',
		contacts: 'Kontakty',
		campaignDetail: 'Detail kampaně',
		toBeAssigned: 'K přidělení',
		toRelease: 'K uvolnění',
	},
};
